/* ==========================================================================
   PRODUCT — galeri, varyant seçici, miktar, mobil sabit sepet çubuğu
   ========================================================================== */

(function () {
  'use strict';

  var root = document.querySelector('[data-product]');
  if (!root) return;

  var dataEl = root.querySelector('[data-variants]');
  var variants = [];
  try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }

  var form = root.querySelector('[data-add-form]');
  var idInput = root.querySelector('[data-variant-id]');
  var priceBox = root.querySelector('[data-price]');
  var addBtn = root.querySelector('[data-add-btn]');
  var addLabel = root.querySelector('[data-add-label]');

  var T = window.themeStrings || {};
  var TXT_ADD = addLabel ? addLabel.textContent.trim() : 'Add to cart';
  var TXT_OUT = T.soldOut || 'Sold out';
  var TXT_NA = T.unavailable || 'Unavailable';

  /* --- Galeri ------------------------------------------------------------- */

  function showMedia(id) {
    root.querySelectorAll('[data-media-id]').forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id));
    });
    root.querySelectorAll('[data-gal-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-gal-thumb') === String(id));
    });
  }

  root.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gal-thumb]');
    if (thumb) showMedia(thumb.getAttribute('data-gal-thumb'));
  });

  /* --- Büyütme -------------------------------------------------------------
     Ceviz damarına yakından bakılabilsin diye. Katman ilk tıklamada
     oluşturuluyor, kapanınca DOM'da kalıp yeniden kullanılıyor.
     ------------------------------------------------------------------------- */

  var lbox = null;

  function closeBox() {
    if (!lbox) return;
    lbox.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    window.setTimeout(function () { if (lbox && !lbox.classList.contains('is-open')) lbox.hidden = true; }, 260);
  }

  function openBox(src, alt) {
    if (!lbox) {
      lbox = document.createElement('div');
      lbox.className = 'lbox';
      lbox.hidden = true;
      lbox.innerHTML =
        '<button class="lbox__close" type="button" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" aria-hidden="true">' +
        '<path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '<img class="lbox__img" alt="">';
      document.body.appendChild(lbox);
      lbox.addEventListener('click', function (e) {
        if (e.target === lbox || e.target.closest('.lbox__close')) closeBox();
      });
    }
    var img = lbox.querySelector('.lbox__img');
    img.src = src;
    img.alt = alt || '';
    lbox.hidden = false;
    void lbox.offsetWidth;
    lbox.classList.add('is-open');
    document.body.classList.add('is-locked');
    lbox.querySelector('.lbox__close').focus({ preventScroll: true });
  }

  root.addEventListener('click', function (e) {
    var slide = e.target.closest('.pgal__slide.is-active');
    if (!slide) return;
    var img = slide.querySelector('img[data-zoom]');
    if (!img) return;
    openBox(img.getAttribute('data-zoom'), img.getAttribute('alt'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lbox && lbox.classList.contains('is-open')) closeBox();
  });

  /* --- Miktar -------------------------------------------------------------- */

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    if (!input) return;
    var next = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10);
    input.value = Math.max(1, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --- Varyant seçimi ------------------------------------------------------ */

  function chosen() {
    var out = [];
    root.querySelectorAll('[data-opt-index]').forEach(function (fs) {
      var i = Number(fs.getAttribute('data-opt-index'));
      /* seçenek sayısına göre ya açılır liste ya radyo düğmesi basılıyor */
      var sel = fs.querySelector('select[data-opt-input]');
      if (sel) { out[i] = sel.value; return; }
      var picked = fs.querySelector('[data-opt-input]:checked');
      out[i] = picked ? picked.value : null;
    });
    return out;
  }

  function match(sel) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < sel.length; j++) {
        if (sel[j] !== null && v.options[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function renderPrice(v) {
    if (!priceBox) return;
    var onSale = v.compare_at > v.price;
    var html = '<div class="price' + (onSale ? '' : ' price--full') + '">' +
      '<span class="price__now">' + v.price_str + '</span>' +
      (onSale ? '<s class="price__was">' + v.compare_str + '</s>' : '') +
      '</div>';
    priceBox.innerHTML = html;

    var bar = root.parentNode.querySelector('[data-pbar-price]');
    if (bar) bar.textContent = v.price_str;
  }

  function update() {
    var v = match(chosen());

    if (!v) {
      if (addBtn) addBtn.setAttribute('aria-disabled', 'true');
      if (addLabel) addLabel.textContent = TXT_NA;
      return;
    }

    if (idInput) idInput.value = v.id;
    renderPrice(v);
    if (v.media_id) showMedia(v.media_id);

    if (addBtn) {
      if (v.available) addBtn.removeAttribute('aria-disabled');
      else addBtn.setAttribute('aria-disabled', 'true');
    }
    if (addLabel) addLabel.textContent = v.available ? TXT_ADD : TXT_OUT;

    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState({}, '', url.toString());
    }
  }

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-opt-input]')) update();
  });

  /* --- Mobil sabit sepet çubuğu -------------------------------------------- */

  var bar = document.querySelector('[data-pbar]');
  if (bar && form && window.IntersectionObserver) {
    var addBtnBar = bar.querySelector('[data-pbar-add]');
    if (addBtnBar) {
      addBtnBar.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    }
    new IntersectionObserver(function (es) {
      bar.hidden = es[0].isIntersecting;
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(form);
  }
})();
